//@ts-nocheck
// const go = async () => {
//   const isAuthenticated_1 = await Lit.Actions.isPermittedAuthMethod({
//     tokenId: tokenId,
//     authMethodType: auth1.authMethodType,
//     userId: ethers.utils.arrayify(auth1.authId),
//   });
//   const isAuthenticated_2 = await Lit.Actions.isPermittedAuthMethod({
//     tokenId: tokenId,
//     authMethodType: auth2.authMethodType,
//     userId: ethers.utils.arrayify(auth2.authId),
//   });
//   LitActions.setResponse({
//     response: isAuthenticated_1 && isAuthenticated_2 ? 'true' : 'false',
//   });
// };
// export const MFA_AUTH_ACTION =
//   'const go = ' + go.toString() + ';' + ' go();';
export var MFA_AUTH_ACTION = "(async () => {\n    const isAuthenticated_1 = await Lit.Actions.isPermittedAuthMethod({\n      tokenId: tokenId,\n      authMethodType: auth1.authMethodType,\n      userId: ethers.utils.arrayify(auth1.authId),\n    });\n    const isAuthenticated_2 = await Lit.Actions.isPermittedAuthMethod({\n      tokenId: tokenId,\n      authMethodType: auth2.authMethodType,\n      userId: ethers.utils.arrayify(auth2.authId),\n    });\n    LitActions.setResponse({\n      response: isAuthenticated_1 && isAuthenticated_2 ? 'true' : 'false',\n    });\n    })();";
